<template>
  <font-awesome-icon
    v-show="showSearchTypeIcon"
    class="search-type-icon"
    :icon="searchTypeIcon"
  />
</template>

<script>
  export default {
    name: 'SearchTypeIcon',
    props: {
      searchString: {
        type: String || Number,
        default: null,
      },
    },
    computed: {
      isNumberSearch () {
        return this.searchString?.length <= 4
      },
      showSearchTypeIcon () {
        return !!this.searchString
      },
      searchTypeIcon () {
        return this.isNumberSearch ? 'hashtag' : 'phone-alt'
      },
    },
  }
</script>

<style scoped lang="less">

</style>
